import { render } from "./printVouchPz.vue?vue&type=template&id=22ddf3f8"
import script from "./printVouchPz.vue?vue&type=script&lang=js"
export * from "./printVouchPz.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__